export default (props, e) => {
	let linkInnerText = e.target.innerText;
	if(linkInnerText !== '') {
		dataLayer.push({
			'event': 'fgWebEvent',
			'fgWebEventAction': 'CTA tlačítko',
			'fgWebEventLabel': linkInnerText
		});
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/handleGtmLayerPush.js